// Import libraries

import { Tooltip, Collapse } from 'bootstrap';
import AnchorJS from 'anchor-js';
// Design-system web components (Lit). Side-effect import registers all
// <m-*> custom elements (m-button, m-accordion, m-tabs, …).
import '@muenchen.de/mde-storybook';
const hljs = require('highlight.js');

hljs.highlightAll();


// Add keyboard shortcut for search bar in header

(function () {
  const input = document.getElementById('sitesearch-input');
  const shortcutSpan = document.getElementById('search-shortcut');
  if (!input || !shortcutSpan) return;

  const isMac = navigator.platform.toUpperCase().includes('MAC');
  const shortcutKey = isMac ? '⌘' : 'Ctrl';

  // Insert shortcut text
  shortcutSpan.textContent = ` ${shortcutKey}+K`;

  // Keyboard focus
  document.addEventListener('keydown', function (e) {
    const isShortcutPressed = (isMac && e.metaKey) || (!isMac && e.ctrlKey);
    if (isShortcutPressed && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      input.focus();
    }
  });
})();


// Init anchor.js


const anchors = new AnchorJS();

anchors.options = {
  icon: '#'
};

anchors.add('h2.mds-content-element__heading');


///
// Offcanvs optimizaiton

document.addEventListener('DOMContentLoaded', () => {
  const offcanvasEls = document.querySelectorAll('.offcanvas');

  offcanvasEls.forEach((offcanvas) => {
    offcanvas.addEventListener('shown.bs.offcanvas', () => {
      document.body.classList.add('offcanvas-open');
      document.body.style.pointerEvents = 'none';
    });

    offcanvas.addEventListener('hidden.bs.offcanvas', () => {
      document.body.classList.remove('offcanvas-open');
      document.body.style.pointerEvents = '';
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.ds-offcanvas-menu__toggle');

  toggles.forEach(toggle => {
    const menu = toggle.nextElementSibling;

    if (!menu || !menu.classList.contains('ds-dropdown-menu')) return;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = menu.classList.contains('is-open');

      if (!isOpen) {
        menu.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.mds-book-menu__toggle');

  toggles.forEach(toggle => {
    const menu = toggle.nextElementSibling;

    if (!menu || !menu.classList.contains('ds-dropdown-menu')) return;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = menu.classList.contains('is-open');

      if (!isOpen) {
        menu.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.js-offcanvas-toggle');
  const panels = document.querySelectorAll('.ds-offcanvas-menu__panel');
  const level1Links = document.querySelectorAll(
    '.ds-offcanvas-menu > .ds-offcanvas-menu__item > .ds-offcanvas-menu__link'
  );

  function disableAllLevel1Links() {
    level1Links.forEach(el => {
      el.setAttribute('tabindex', '-1');
    });
  }

  function enableAllLevel1Links() {
    level1Links.forEach(el => {
      el.removeAttribute('tabindex');
    });
  }

  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const parentItem = toggle.closest('.ds-offcanvas-menu__item--has-children');
      const panel = parentItem.querySelector('.ds-offcanvas-menu__panel');

      // Alle Panels schließen
      panels.forEach(p => p.classList.remove('show'));

      // Panel öffnen
      panel.classList.add('show');
      toggle.setAttribute('aria-expanded', 'true');

      // Alle erste-Ebene-Links deaktivieren – inkl. des Triggers selbst
      disableAllLevel1Links();

      // Fokus ins Panel (z. B. auf erstes <a> oder <button>)
      const focusTarget = panel.querySelector('a, button');
      focusTarget?.focus();
    });
  });

  const backButtons = document.querySelectorAll('.ds-offcanvas-menu__back');
  backButtons.forEach(back => {
    back.addEventListener('click', () => {
      const panel = back.closest('.ds-offcanvas-menu__panel');
      const parentItem = panel.closest('.ds-offcanvas-menu__item--has-children');
      const toggle = parentItem.querySelector('.js-offcanvas-toggle');

      // Panel schließen
      panel.classList.remove('show');
      toggle.setAttribute('aria-expanded', 'false');

      // Fokus zurück auf Trigger
      toggle.focus();

      // Erste-Ebene-Links wieder aktivieren
      enableAllLevel1Links();
    });
  });
});


///
// Console Easter Egg

console.log(
  '%c Hello World! Hello Munich! 🥨 ',
  'background: #005A9F; color: #fff; padding: 0.125rem'
);


///
// Header shadow
///

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.mds-header');

  if (!header) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 10) {
      header.classList.add('mds-header--shadow');
    } else {
      header.classList.remove('mds-header--shadow');
    }
  });
});
